<template>
    <v-container grid-list-xl>

        <cook :loading="loading" v-if="infinteScrollCooks.cooks" :cooks="infinteScrollCooks.cooks" v-on:deleteCook="deleteCook" />

        <v-layout row>
            <!-- Added Successfully -->
            <v-snackbar v-model="successMessage" color="success" :timeout="6000" bottom left>
                <v-icon class="mr-3">mdi-check-circle</v-icon>
                <h3>{{successMessage}}</h3>
            </v-snackbar>

            <!-- Error when adding cook -->
            <v-snackbar v-model="error" color="warning" :timeout="6000" bottom left>
                <v-icon class="mr-3">mdi-cancel</v-icon>
                <h3>{{error}}</h3>
            </v-snackbar>

            <v-dialog v-model="loading" v-if="!loading" persistent fullscreen>
                <v-container fill-height>
                    <v-layout row justify-center align-center>
                        <v-progress-circular indeterminate :size="70" :width="7" color="secondary"></v-progress-circular>
                    </v-layout>
                </v-container>
            </v-dialog>
        </v-layout>

        <v-layout v-if="showMoreCooks" column>
            <v-flex xs12>
                <v-layout justify-center row>
                    <v-btn color="#FACD47" class="black-text" :disabled="!showMoreEnabled" @click="showMoreCooks">جلب المزيد</v-btn>
                </v-layout>
            </v-flex>
        </v-layout>

    </v-container>
</template>

<script>
    import {
        INFINITE_SCROLL_COOKS
    } from '../../graphql/Cooks'
    import {
        mapGetters
    } from 'vuex'
    import Cook from '../Shared/Cook.vue'

    const pageSize = 9

    export default {
        name: 'Cooks',
        data() {
            return {
                pageNum: 1,
                showMoreEnabled: true,
                infinteScrollCooks: ''
            }
        },
        apollo: {
            infinteScrollCooks: {
                query: INFINITE_SCROLL_COOKS,
                variables: {
                    pageNum: 1,
                    pageSize
                }
            }
        },
        components: {
            'cook': Cook
        },
        computed: {
            ...mapGetters(['loading', 'user', 'error', 'successMessage'])
        },
        watch: {
            user(value) {
                // If user value changes, redirect to home page
                if(value) {
                    this.$router.push('/')
                }
            }
        },
        methods: {
            deleteCook(cookId) {
                this.$store.dispatch('deleteCook', cookId)               
            },
            showMoreCooks() {
                this.pageNum += 1
                // fretch more data and transform original result
                this.$apollo.queries.infinteScrollCooks.fetchMore({
                    variables: {
                        // pageNum incremented by 1
                        pageNum: this.pageNum,
                        pageSize
                    },
                    updateQuery: (prevResult, {
                        fetchMoreResult
                    }) => {

                        const newCooks = fetchMoreResult.infinteScrollCooks.cooks
                        const hasMore = fetchMoreResult.infinteScrollCooks.hasMore
                        this.showMoreEnabled = hasMore

                        return {
                            infinteScrollCooks: {
                                __typename: prevResult.infinteScrollCooks.__typename,
                                // merge previous cooks with new cooks
                                cooks: [
                                    ...prevResult.infinteScrollCooks.cooks,
                                    ...newCooks
                                ],
                                hasMore
                            }
                        }
                    }
                })
            },
            goToCook(cookId) {
                this.$router.push(`/cooks/${cookId}`)
            }
        }
    }
</script>

<style scoped>
.cook-1 {
    font-size: 2.125rem !important;
    font-weight: 400;
    line-height: 2.5rem;
    letter-spacing: 0.0073529412em !important;
    font-family: 'Almarai', sans-serif !important; /* this was it */
}
</style>